export function formatWaitTime(waitingMs: number) {
  const minutes = Math.max(0, Math.floor(waitingMs / 60_000));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const remMinutes = minutes % 60;
  if (hours < 24) {
    if (!remMinutes) return hours === 1 ? "1 hour" : `${hours} hours`;
    return `${hours}h ${remMinutes}m`;
  }
  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  if (days < 14) {
    if (!remHours) return days === 1 ? "1 day" : `${days} days`;
    return `${days}d ${remHours}h`;
  }
  const weeks = Math.floor(days / 7);
  return `${weeks}w ${days % 7}d`;
}

export function waitMsSince(isoDate: string, now = Date.now()) {
  const at = new Date(isoDate).getTime();
  if (!Number.isFinite(at)) return 0;
  return Math.max(0, now - at);
}

export function formatSince(isoDate: string, timeZone = "America/New_York") {
  const at = new Date(isoDate);
  if (!Number.isFinite(at.getTime())) return "";
  return at.toLocaleString("en-US", {
    timeZone,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
